import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../common/Fieldset";
import TextAreaInput from "../common/TextAreaInput";
import TextInput from "../common/TextInput";
import RadioButtonGroup from "../common/RadioButtonGroup";
import * as constants from "../../constants/DomainConstants";

const DossierFieldset = (props) => {
    const { naamLeidinggevende, naam, omschrijving, disabled, onChange, onChangeDossierSoort, errors, email, soortDossier, verdwijnenErInfrastructuren, verdwijnenErInfrastructurenNietInSpakki, sportinfrastructurenInDeBuurt, validationMessageType } = props;
    const DOSSIERNAAM_TOOLTIP = "Een dossiernaam bestaat uit de naam van de sportinfrastructuur. Bijvoorbeeld: S&R Olympia of Euro Volley Center. ";
    const sportInfrastructurenNieuwbouw = sportinfrastructurenInDeBuurt ? sportinfrastructurenInDeBuurt.filter(i => i.soortWerken === constants.INFRASTRUCTUUR_TYPE.NIEUWBOUW) : [];
    const sportInfrastructurenRenovatie = sportinfrastructurenInDeBuurt ? sportinfrastructurenInDeBuurt.filter(i => i.soortWerken !== constants.INFRASTRUCTUUR_TYPE.NIEUWBOUW) : [];

    const soortDossierProps = {
        disabled: disabled,
        label: "Soort werken",
        value: soortDossier,
        name: "soortDossier",
        labelInside: true,
        horizontal: true,
        items: [
            { value: constants.DOSSIER_SOORT_NIEUWBOUW, label: 'Nieuwbouw' },
            { value: constants.DOSSIER_SOORT_RENOVATIE, label: 'Renovatie' },
            { value: constants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE, label: "Nieuwbouw + Renovatie" }],
        itemsLocked: [
            { locked: (sportInfrastructurenRenovatie.length > 0 && sportInfrastructurenRenovatie.filter(x => x.deelVanAanvraag.toString() === "0").length > 0), text: "De optie nieuwbouw kan niet geselecteerd worden want er werden reeds renovatie infrastructuren aangeduid of toegevoegd." },
            { locked: (sportInfrastructurenNieuwbouw.length > 0), text: "De optie renovatie kan niet geselecteerd worden want er werden reeds nieuwbouwinfrastructuren toegevoegd." },
            { locked: false, text: "" }
        ],
        onChange: onChangeDossierSoort,
        validationMessage: errors ? errors["soortDossier"] : '',
        validationMessageType: validationMessageType
    };

    const verdwijnenErInfrastructurenProps = {
        disabled: disabled,
        label: "Zullen er bestaande sportinfrastructuren verdwijnen door de geplande werkzaamheden?",
        value: verdwijnenErInfrastructuren,
        labelInside: true,
        horizontal: true,
        tooltip: "Duid “ja” aan indien sportinfrastructuur fysiek verdwijnt en niet meer zal worden geëxploiteerd.",
        name: "verdwijnenErInfrastructuren",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        lockedText: "Het antwoord op deze vraag kan niet gewijzigd worden wanneer er al verdwijnende infrastructuren werden aangeduid.",
        locked: (verdwijnenErInfrastructuren &&
            (sportinfrastructurenInDeBuurt.filter(x => x.deelVanAanvraag.toString() === "2").length > 0 ||
                (sportInfrastructurenRenovatie.filter(x => !!x.spakki).length > 0 && verdwijnenErInfrastructurenNietInSpakki)))
    };

    return (<Fieldset title="Dossier">
        <TextInput
            label=" "
            style={{ border: '0px', width: '100px' }}
            surroundingStyle={{ position: 'absolute', left: '-999px' }}
            name="naamLeidinggevende"
            value={naamLeidinggevende}
            onChange={onChange}
            disabled={disabled}
        />
        <TextInput
            label="Naam van het project"
            name="naam"
            value={naam}
            onChange={onChange}
            disabled={disabled}
            validationMessage={errors ? errors.naam : ''}
            validationMessageType={validationMessageType}
            tooltip={DOSSIERNAAM_TOOLTIP}
            maxLength={100}
        />
        <TextAreaInput
            label="Omschrijving"
            name="omschrijving"
            disabled={disabled}
            value={omschrijving}
            onChange={onChange}
            height={4}
            validationMessage={errors ? errors.omschrijving : ''}
            validationMessageType={validationMessageType}
            maxLength={500}
        />
        <TextInput
            label="E-mail"
            name="email"
            value={email}
            onChange={onChange}
            disabled={disabled}
            validationMessage={errors ? errors.email : ''}
            validationMessageType={validationMessageType}
            maxLength={100} />

        <RadioButtonGroup {...soortDossierProps} />

        <RadioButtonGroup {...verdwijnenErInfrastructurenProps} />

    </Fieldset>);
};

DossierFieldset.propTypes = {
    naam: PropTypes.string,
    omschrijving: PropTypes.string,
    naamLeidinggevende: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeDossierSoort: PropTypes.func,
    errors: PropTypes.object,
    email: PropTypes.string,
    soortDossier: PropTypes.string,
    verdwijnenErInfrastructuren: PropTypes.bool,
    verdwijnenErInfrastructurenNietInSpakki: PropTypes.bool,
    sportinfrastructurenInDeBuurt: PropTypes.array,
    validationMessageType: PropTypes.string
};

export default DossierFieldset;